import { render } from "./BreadcrumbItem.vue?vue&type=template&id=0c3d28e6"
import script from "./BreadcrumbItem.vue?vue&type=script&lang=js"
export * from "./BreadcrumbItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Navigation/BreadcrumbItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c3d28e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c3d28e6', __exports__)) {
    api.reload('0c3d28e6', __exports__)
  }
  
  module.hot.accept("./BreadcrumbItem.vue?vue&type=template&id=0c3d28e6", () => {
    api.rerender('0c3d28e6', render)
  })

}


export default __exports__